import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class AdminSettingsInvoicesArchiveService {
  private search_invoices$ = new Subject<string>();
  
  listenInvoicesSearch() {
    return this.search_invoices$.asObservable();
  }

  setInvoicesSearch(search: string) {
    this.search_invoices$.next(search);
  }
}